import stringHelper from '@/Scripts/lib/helper/stringHelper.js';

export const ProductViewAsFemale = function (gender, urlString) {
  if (gender === 'Unisex') {
    const regex = new RegExp(urlString, 'i');
    return stringHelper.getURLParameter('women') === 'true' || regex.test(window.location.pathname);
  }
  return stringHelper.getURLParameter('women') === 'true';
};
export const ProductSortSizes = function (sizeArr) {
  return [...sizeArr].sort((a, b) =>
    a.SizeSort > b.SizeSort ? 1 : b.SizeSort > a.SizeSort ? -1 : 0
  );
};
export const ProductPrices = function (variant) {
  if (variant && variant.Price) {
    return {
      price: Math.ceil(variant.Price.VariantAmount),
      fullPrice: Math.ceil(variant.Price.FullPrice),
      hasDiscount: variant.Price.DiscountPercentage > 0,
      currencyCode: variant.Price.CurrencyCode
    };
  }
  return {};
};

export const ProductConvertToOldModel = function (model, currentVariant) {
  return {
    Concept: model.Concept,
    Name: model.Name,
    Gender: model.Gender,
    Url: currentVariant.Url,
    Variant: {
      ImageUrl: {
        Path: currentVariant.ModelShotPath || currentVariant.PackShotPath
      },
      Color: {
        Name: currentVariant.ColorName
      },
      Size: ''
    }

  };
};

export const ProductSkuToObject = function (sku) {
  const parts = sku.split(' ');
  if (parts.length > 3) {
    parts[2] = `${parts[2]} ${parts[3]}`;
  }
  return {
    code: parts[0],
    color: parts[1],
    size: parts[2],
    variant: `${parts[0]} ${parts[1]}`
  };
};
